import { useQuery, useMutation, useQueryClient } from '../lib/queryClient';
import { getSitesList } from '../endpoints/sites/list_GET.schema';
import { publishSite } from '../endpoints/sites/publish_POST.schema';
import { updateSite } from '../endpoints/sites/update_POST.schema';
import { deleteSite } from '../endpoints/sites/delete_POST.schema';
import { manageSiteDatabase } from '../endpoints/sites/database_POST.schema';

export const usePublishedSites = (sessionId?: string) => {
  return useQuery({
    queryKey: ['sites', 'list', sessionId],
    queryFn: () => getSitesList({ sessionId }),
  });
};

export const usePublishSite = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: publishSite,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['sites', 'list'] });
      if (variables.sessionId) {
        queryClient.invalidateQueries({ queryKey: ['sites', 'list', variables.sessionId] });
      }
    },
  });
};

export const useUpdateSite = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateSite,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sites', 'list'] });
    },
  });
};

export const useDeleteSite = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteSite,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sites', 'list'] });
    },
  });
};

export const useManageSiteDatabase = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: manageSiteDatabase,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sites', 'list'] });
    },
  });
};
